import React from 'react'

const EmailForm = () => {
  return (
    <></>
  )
}

export default EmailForm